(function() {
  'use strict';

  // =========================================================================
  // Header - Mobile Menu Toggle + Scroll Hide
  // =========================================================================
  function initHeader() {
    var header = document.querySelector('.header-minimal');
    var toggle = document.querySelector('.header-minimal__toggle');
    if (!header || !toggle) return;

    toggle.addEventListener('click', function() {
      var isOpen = header.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });

    document.addEventListener('click', function(e) {
      if (!header.contains(e.target) && header.classList.contains('menu-open')) {
        header.classList.remove('menu-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    var urgencyBar = document.getElementById('urgency-bar');
    var lastScroll = 0;
    var headerHidden = false;
    var GAP = 12;

    function getHeaderTop() {
      if (urgencyBar) {
        var barRect = urgencyBar.getBoundingClientRect();
        var barBottom = barRect.bottom;
        if (barBottom > 0) return barBottom + GAP;
      }
      return GAP;
    }

    function onScroll() {
      var current = window.scrollY;
      var delta = current - lastScroll;

      if (delta > 5 && current > 80) {
        if (!headerHidden) {
          header.style.setProperty('--header-top', '-80px');
          headerHidden = true;
        }
      } else if (delta < -3) {
        header.style.setProperty('--header-top', getHeaderTop() + 'px');
        headerHidden = false;
      } else if (!headerHidden) {
        header.style.setProperty('--header-top', getHeaderTop() + 'px');
      }

      lastScroll = current;
    }

    header.style.setProperty('--header-top', getHeaderTop() + 'px');
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // =========================================================================
  // Urgency Bar - Countdown & Viewer Count
  // =========================================================================
  function initUrgency() {
    var el1 = document.getElementById('urgency-countdown');
    var el2 = document.getElementById('urgency-countdown-2');
    var viewerEl = document.getElementById('urgency-viewers');
    if (!el1 && !viewerEl) return;

    if (el1) {
      var endTime = Date.now() + 3600000;
      function updateCountdown() {
        var diff = endTime - Date.now();
        if (diff <= 0) { endTime = Date.now() + 3600000; diff = endTime - Date.now(); }
        var mins = Math.floor(diff / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        var text = String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
        if (el1) el1.textContent = text;
        if (el2) el2.textContent = text;
      }
      updateCountdown();
      setInterval(updateCountdown, 1000);
    }

    if (viewerEl) {
      setInterval(function() {
        var base = parseInt(viewerEl.textContent) || 43;
        var delta = Math.floor(Math.random() * 7) - 3;
        viewerEl.textContent = Math.max(28, Math.min(67, base + delta));
      }, 4000 + Math.random() * 3000);
    }
  }

  // =========================================================================
  // FAQ Accordion
  // =========================================================================
  function initFAQ() {
    document.querySelectorAll('[data-faq-item]').forEach(function(item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger || item.dataset.faqInit) return;
      item.dataset.faqInit = 'true';
      trigger.addEventListener('click', function() {
        var isOpen = item.classList.contains('is-open');
        item.closest('.faq__list').querySelectorAll('[data-faq-item]').forEach(function(o) { o.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', !isOpen);
      });
    });
  }

  // =========================================================================
  // Live Sales Notifications
  // =========================================================================
  function initLiveSales() {
    var widget = document.getElementById('live-sales-notification');
    if (!widget) return;

    var products = [];
    try { products = JSON.parse(decodeURIComponent(widget.dataset.products)); } catch(e) { return; }
    if (!products.length) return;

    var displayDuration = parseInt(widget.dataset.displayDuration) || 7000;
    var minDelay = parseInt(widget.dataset.minDelay) || 8000;
    var maxDelay = parseInt(widget.dataset.maxDelay) || 20000;
    var initialDelay = parseInt(widget.dataset.initialDelay) || 5000;
    var firstNames = ['James','Emma','Liam','Olivia','Noah','Ava','Mason','Sophia','Ethan','Isabella','Logan','Mia','Lucas','Charlotte','Alex','Harper','Ryan','Ella','Jack','Luna','Tyler','Chloe','Dylan','Grace'];
    var nameEl = widget.querySelector('.live-sales-notification__name');
    var productEl = widget.querySelector('.live-sales-notification__product');

    function show() {
      nameEl.textContent = firstNames[Math.floor(Math.random() * firstNames.length)];
      productEl.textContent = products[Math.floor(Math.random() * products.length)];
      widget.classList.add('live-sales-visible');
      setTimeout(function() {
        widget.classList.remove('live-sales-visible');
        setTimeout(show, minDelay + Math.random() * (maxDelay - minDelay));
      }, displayDuration);
    }
    setTimeout(show, initialDelay);
  }

  // =========================================================================
  // Cart Functions (shared)
  // =========================================================================
  function updateCartCount() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.header-minimal__cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        var ids = cart.items.map(function(i) { return String(i.variant_id); });
        document.querySelectorAll('[data-variant-id]').forEach(function(btn) {
          btn.classList.toggle('in-cart', ids.includes(btn.dataset.variantId));
        });
        return cart;
      })
      .catch(function() { return null; });
  }

  function initAddToCart() {
    updateCartCount();
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__cart-btn, .spg-card__cart-btn');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function() { btn.classList.add('in-cart'); updateCartCount(); })
      .catch(function() {})
      .finally(function() { btn.disabled = false; });
    });
  }

  // =========================================================================
  // Product Page - Variant Selector + Image Switcher
  // =========================================================================
  function initProductPage() {
    var form = document.getElementById('product-form');
    var select = document.getElementById('product-variant-select');
    var jsonEl = document.getElementById('product-json');
    if (!form || !select || !jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch(e) { return; }

    var mainImg = document.getElementById('product-image-main');
    var thumbs = document.querySelectorAll('.product-page__thumb');
    var addBtn = document.getElementById('add-to-cart-btn');
    var buyBtn = document.getElementById('buy-now-btn');
    var priceContainer = document.getElementById('product-price');
    var currentOptions = [];

    product.options.forEach(function(_, i) {
      var active = document.querySelector('.product-page__option-btn.active[data-option-index="' + i + '"]');
      currentOptions[i] = active ? active.dataset.value : '';
    });

    document.querySelectorAll('.product-page__option-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(btn.dataset.optionIndex);
        currentOptions[idx] = btn.dataset.value;
        btn.closest('.product-page__option-values').querySelectorAll('.product-page__option-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        updateVariant();
      });
    });

    function updateVariant() {
      var match = product.variants.find(function(v) {
        return v.options.every(function(opt, i) { return opt === currentOptions[i]; });
      });
      if (!match) return;

      select.value = match.id;

      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (addBtn.dataset.text || 'Add to Cart') : 'Sold Out';
      }
      if (buyBtn) {
        buyBtn.href = '/cart/add?id=' + match.id + '&return_to=/checkout';
        buyBtn.style.display = match.available ? '' : 'none';
      }

      if (priceContainer) {
        var price = '$' + (match.price / 100).toFixed(2);
        var compare = match.compare_at_price ? '$' + (match.compare_at_price / 100).toFixed(2) : '';
        var html = '';
        if (compare && match.compare_at_price > match.price) {
          var savings = Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100);
          html = '<span class="product-page__current-price product-page__current-price--sale">' + price + '</span>' +
            '<span class="product-page__compare-price">' + compare + '</span>' +
            '<span class="product-page__savings">Save ' + savings + '%</span>';
        } else {
          html = '<span class="product-page__current-price">' + price + '</span>';
        }
        priceContainer.innerHTML = html;
      }

      if (match.featured_image && mainImg) {
        mainImg.src = match.featured_image.src;
      }
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg) mainImg.src = thumb.dataset.imageUrl;
      });
    });

    form.addEventListener('submit', function(e) {
  e.preventDefault();
  if (addBtn) addBtn.disabled = true;

  const qtyInput = form.querySelector('input[name="quantity"]');
  const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(select.value), quantity: qty }] })
  })
      .then(function() {
        updateCartCount();
        if (addBtn) { addBtn.textContent = '✓ Added!'; setTimeout(function() { addBtn.textContent = addBtn.dataset.text || 'Add to Cart'; addBtn.disabled = false; }, 2000); }
      })
      .catch(function() { if (addBtn) addBtn.disabled = false; });
    });
  }

  // =========================================================================
  // Cart Page - Quantity & Remove
  // =========================================================================
  function initCartPage() {
    var cartItems = document.querySelector('.cart-page__items');
    if (!cartItems) return;

    function updateCart(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function() { window.location.reload(); });
    }

    cartItems.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-action]');
      if (btn) {
        var key = btn.dataset.key;
        var qtyEl = btn.closest('.cart-page__item').querySelector('.cart-page__qty-value');
        var qty = parseInt(qtyEl.textContent);
        if (btn.dataset.action === 'decrease') updateCart(key, Math.max(0, qty - 1));
        if (btn.dataset.action === 'increase') updateCart(key, qty + 1);
        return;
      }

      var removeBtn = e.target.closest('.cart-page__item-remove');
      if (removeBtn) {
        updateCart(removeBtn.dataset.key, 0);
      }
    });
  }

  // =========================================================================
  // Chat Widget
  // =========================================================================
  function initChat() {
    var widget = document.getElementById('scaled-chat-widget');
    if (!widget) return;

    var windowEl = widget.querySelector('.chat-widget__window');
    var popup = document.getElementById('chat-popup');
    var popupText = document.getElementById('chat-popup-text');
    var messages = document.getElementById('chat-messages');
    var input = document.getElementById('chat-input');
    var sendBtn = document.getElementById('chat-send');
    var isOpen = false;

    var welcomeMsg = widget.dataset.welcome || "Hey! 👋 How can I help?";
    var popupMsg = widget.closest('[data-popup-message]')
      ? widget.closest('[data-popup-message]').dataset.popupMessage
      : "👋 Need help finding the right product?";

    window.ScaledChat = {
      toggle: function() {
        isOpen = !isOpen;
        windowEl.style.display = isOpen ? 'flex' : 'none';
        if (isOpen && popup) popup.style.display = 'none';
        if (isOpen) {
          document.body.classList.add('chat-open');
          if (input) input.focus();
          if (messages && messages.children.length === 0) addMessage('bot', welcomeMsg);
        } else {
          document.body.classList.remove('chat-open');
        }
      },
      hidePopup: function() { if (popup) popup.style.display = 'none'; },
      send: function(text) {
        if (!text || !text.trim()) return;
        addMessage('user', text.trim());
        if (input) input.value = '';
        showTyping();
        setTimeout(function() { hideTyping(); addMessage('bot', getAutoResponse(text.trim())); }, 1000 + Math.random() * 1500);
      }
    };

    function addMessage(type, text) {
      if (!messages) return;
      var div = document.createElement('div');
      div.className = 'chat-widget__message chat-widget__message--' + type;
      div.innerHTML = '<p>' + text + '</p>';
      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;
    }

    function showTyping() {
      if (!messages) return;
      var div = document.createElement('div');
      div.className = 'chat-widget__message chat-widget__message--typing';
      div.id = 'chat-typing';
      div.innerHTML = '<div class="chat-widget__typing-dots"><span></span><span></span><span></span></div>';
      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;
    }

    function hideTyping() { var t = document.getElementById('chat-typing'); if (t) t.remove(); }

    function getAutoResponse(text) {
      var l = text.toLowerCase();
      if (l.includes('price') || l.includes('cost') || l.includes('how much')) return "Check out our products on the homepage! We have great deals and bundles available. 🎯";
      if (l.includes('ship') || l.includes('deliver')) return "All products are delivered instantly via email right after purchase! ⚡";
      if (l.includes('refund') || l.includes('return')) return "We offer a satisfaction guarantee! Check our refund policy at the bottom of the page for details.";
      if (l.includes('bundle')) return "Our bundles offer the best value — check them out on the homepage! 🔥";
      if (l.includes('help') || l.includes('support')) return "I'm here to help! Feel free to ask about our products, shipping, or anything else. 😊";
      return "Thanks for your message! Check out our products on the homepage, or ask me about shipping, pricing, or any specific product! 😊";
    }

    if (sendBtn && input) {
      sendBtn.addEventListener('click', function() { window.ScaledChat.send(input.value); });
      input.addEventListener('keydown', function(e) { if (e.key === 'Enter') window.ScaledChat.send(input.value); });
    }

    setTimeout(function() {
      if (!isOpen && popup && popupText) {
        popupText.textContent = popupMsg;
        popup.style.display = 'block';
      }
    }, 8000);
  }

  // =========================================================================
  // Reviews (Static Display)
  // =========================================================================
  function initReviews() {
    var section = document.getElementById('scaled-reviews');
    if (!section) return;

    var list = document.getElementById('reviews-list');
    var starsEl = document.getElementById('reviews-stars');
    var ratingEl = document.getElementById('reviews-rating');
    var countEl = document.getElementById('reviews-count');
    var writeBtn = document.getElementById('write-review-btn');
    var modal = document.getElementById('review-modal');
    var modalClose = document.getElementById('review-modal-close');
    var modalBackdrop = document.getElementById('review-modal-backdrop');

    function stars(n) { return '\u2605'.repeat(Math.round(n)) + '\u2606'.repeat(5 - Math.round(n)); }

    var sampleReviews = [
      { name: 'James T.', rating: 5, text: 'Amazing quality! Already seeing great results.', date: '2 days ago' },
      { name: 'Sarah M.', rating: 5, text: 'Best purchase I\'ve made. Everything is legit and works perfectly.', date: '5 days ago' },
      { name: 'Chris R.', rating: 4, text: 'Great value for the price. The bundle deal saved me a lot.', date: '1 week ago' },
      { name: 'Alex K.', rating: 5, text: 'Changed my game completely. Highly recommend!', date: '1 week ago' },
      { name: 'Morgan P.', rating: 5, text: 'The quality is unmatched. 10/10 would recommend.', date: '2 weeks ago' },
      { name: 'Jordan L.', rating: 4, text: 'Solid product, fast delivery. Happy with my purchase.', date: '2 weeks ago' },
    ];

    if (starsEl) starsEl.textContent = stars(4.8);
    if (ratingEl) ratingEl.textContent = '4.8';
    if (countEl) countEl.textContent = '(6,489 reviews)';

    if (list) {
      list.innerHTML = sampleReviews.map(function(r) {
        return '<div class="review-card"><div class="review-card__header"><div class="review-card__author"><div class="review-card__avatar">' +
          r.name.charAt(0) + '</div><div><p class="review-card__name">' + r.name + '</p><p class="review-card__date">' + r.date +
          '</p></div></div><div class="review-card__stars">' + stars(r.rating) + '</div></div><p class="review-card__text">' + r.text +
          '</p><span class="review-card__verified">\u2713 Verified Purchase</span></div>';
      }).join('');
    }

    if (writeBtn && modal) writeBtn.addEventListener('click', function() { modal.style.display = 'flex'; });
    if (modalClose) modalClose.addEventListener('click', function() { modal.style.display = 'none'; });
    if (modalBackdrop) modalBackdrop.addEventListener('click', function() { modal.style.display = 'none'; });

    var ratingInput = document.getElementById('rating-input');
    if (ratingInput) {
      var starBtns = ratingInput.querySelectorAll('.review-modal__star');
      starBtns.forEach(function(btn, idx) {
        btn.addEventListener('click', function() {
          starBtns.forEach(function(b, i) { b.classList.toggle('active', i <= idx); });
          var hidden = document.getElementById('rating-value');
          if (hidden) hidden.value = idx + 1;
        });
      });
    }

    var form = document.getElementById('review-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var success = document.createElement('div');
        success.className = 'review-modal__success';
        success.innerHTML = '<div style="font-size:48px">\u2713</div><h4>Thank you!</h4><p>Your review has been submitted.</p>';
        form.style.display = 'none';
        form.parentElement.appendChild(success);
        setTimeout(function() { modal.style.display = 'none'; form.style.display = ''; if (success.parentElement) success.remove(); form.reset(); }, 2500);
      });
    }
  }

  // =========================================================================
  // Boot
  // =========================================================================
  function init() {
    initHeader();
    initUrgency();
    initFAQ();
    initLiveSales();
    initAddToCart();
    initChat();
    initReviews();
    initProductPage();
    initCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

document.querySelectorAll('.quantity-selector').forEach(wrapper => {
  const input = wrapper.querySelector('.qty-input');
  const minus = wrapper.querySelector('.minus');
  const plus = wrapper.querySelector('.plus');

  minus.addEventListener('click', () => {
    let value = parseInt(input.value) || 1;
    if (value > 1) input.value = value - 1;
  });

  plus.addEventListener('click', () => {
    let value = parseInt(input.value) || 1;
    input.value = value + 1;
  });
});
